module.exports = __webpack_public_path__ + "static/media/fresh-air-icon.ba44622c.svg";